import { __assign } from '../../../external/tslib/tslib.es6.mjs.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import clsx from 'clsx';
import { useFocusRing, VisuallyHidden } from 'react-aria';
import { Tooltip } from '../../../base/tooltip/Tooltip.js';
import { CheckIcon } from '../../../icons/CheckIcon.js';
import styles from './CarPart.module.scss.js';

var CarPart = function (_a) {
    var _b;
    var id = _a.id, label = _a.label, size = _a.size, isSelected = _a.isSelected, onToggle = _a.onToggle;
    var _c = useFocusRing(), focusProps = _c.focusProps, isFocusVisible = _c.isFocusVisible;
    return (jsx(Tooltip, __assign({ offset: 6, id: id, content: label, className: styles.carPartTooltip }, { children: jsxs("label", __assign({ className: clsx(styles.carPart, (_b = {},
                _b[styles.carPartLarge] = size === 'large',
                _b[styles.carPartFocused] = isFocusVisible,
                _b[styles.carPartSelected] = isSelected,
                _b)), htmlFor: id, "aria-label": label }, { children: [jsx(VisuallyHidden, { children: jsx("input", __assign({ type: "checkbox", id: id, name: id, "aria-checked": isSelected, checked: isSelected, onChange: function () {
                            onToggle(id);
                        } }, focusProps)) }), jsx(CheckIcon, { "aria-hidden": true })] })) })));
};

export { CarPart };
